import crawlApi, { type CrawlRequestBody } from './crawlApi';

const anchortTextApi = crawlApi.injectEndpoints({
  endpoints: build => ({
    getCountGroup: build.query<unknown, CrawlRequestBody>({
      query: (body: CrawlRequestBody) => ({
        url: `/khazesh/v3/anchor_texts/count_group`,
        method: 'POST',
        body: body
      })
    })
  })
});

export const { useGetCountGroupQuery } = anchortTextApi;
export default anchortTextApi;
